@if (loading) {
  <div class="overlay full" id="follow-up-table-loadingSpinner">
    <p class="text-center">{{ appStrings.pleaseWait }}</p>
    <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}

<!-- desktop template -->
<mat-expansion-panel *appIsDesktop [expanded]="false" hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title id="follow-up-header-container">
      <span class="follow-up-header-title">
        <span id="follow-up-title" class="title">
          {{ appStrings.followUp_title }}
        </span>
        <span id="follow-up-header-closed"
        class="crm-industrial-font icon-keyboard-arrow-down"></span>
        <span id="follow-up-header-opened"
        class="crm-industrial-font icon-keyboard-arrow-up"></span>
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ds-divider></ds-divider>
  <div class="tabs-container">
    @if (activeTab === tabs.Leads) {
      <div id="leads-actions-container" class="actions-container">
        <app-follow-up-search [accountManagerEmployeeId]="accountManagerEmployeeId" [activeTab]="tabs.Leads" (searchEvent)="searchLeads()"></app-follow-up-search>
        @if (!isAccountManager) {
          <ds-divider class="vertical-divider" [vertical]="true"></ds-divider>
        }
        @if (!isAccountManager) {
          <ds-button size="medium" type="tertiary" variant="label-icon" icon="download" [label]="appStrings.button_downloadExcel"
            iconPosition="left" iconStyle="material-icons" (onClick)="handleDownloadExcel()" id="downloadExcel"
          ></ds-button>
        }
        <input #fileUploadControl id="leadsUploadExcelHidden" type="file" accept=".xlsx;*.xls" (change)="uploadExcel($event)"
          name="uploadLeadsExcelButton" class="hidden" />
          @if (!isAccountManager) {
            <ds-button size="medium" type="tertiary" variant="label-icon" icon="upload" [label]="appStrings.button_importLeads"
              iconPosition="left" iconStyle="material-icons" (onClick)="handleUploadExcel()" id="uploadExcel"
            ></ds-button>
          }
          <ds-divider class="vertical-divider" [vertical]="true"></ds-divider>
          <ds-button size="medium" type="secondary" variant="label-icon" icon="add" [label]="appStrings.button_addNew"
            iconPosition="left" iconStyle="material-icons" (onClick)="handleAddNew()" id="addNewLead"
          ></ds-button>
        </div>
      }
      @if (activeTab === tabs.LeadsHistory) {
        <div id="history-actions-container" class="actions-container">
          <app-follow-up-search [accountManagerEmployeeId]="accountManagerEmployeeId" [activeTab]="tabs.LeadsHistory" (searchEvent)="searchLeadsHistory()"></app-follow-up-search>
        </div>
      }
      @if (activeTab === tabs.Projects) {
        <div id="open-projects-actions-container" class="actions-container">
          <app-follow-up-search [accountManagerEmployeeId]="accountManagerEmployeeId" [activeTab]="tabs.Projects" (searchEvent)="searchProjects()"></app-follow-up-search>
          <ds-divider class="vertical-divider" [vertical]="true"></ds-divider>
          <ds-button size="medium" type="secondary" variant="label-icon" icon="add" [label]="appStrings.button_addNew"
            iconPosition="left" iconStyle="material-icons" (onClick)="addNewProject()" id="addNewProject"
          ></ds-button>
        </div>
      }
      @if (activeTab === tabs.ProjectsHistory) {
        <div id="open-projects-actions-container" class="actions-container">
          <app-follow-up-search [accountManagerEmployeeId]="accountManagerEmployeeId" [activeTab]="tabs.ProjectsHistory" (searchEvent)="searchProjectsHistory()"></app-follow-up-search>
        </div>
      }
      <ds-tabs (selectedIndexChange)="onTabChange($event)" [@.disabled]="true">
        <ng-template ds-tab [label]="appStrings.followUp_leads_title">
          <div class="leads-content">
            <div id="data-container" class="data-container">
              <app-leads-table #leads [isHistory]="false"></app-leads-table>
            </div>
          </div>
        </ng-template>
        <ng-template ds-tab [label]="appStrings.followUp_leadsHistory_title">
          <div class="leads-content">
            <div id="data-container" class="data-container">
              <app-leads-table #leadsHistory [isHistory]="true"></app-leads-table>
            </div>
          </div>
        </ng-template>
        <ng-template ds-tab [label]="appStrings.followUp_projects_title">
          <div class="projects-content">
            <div id="data-container" class="data-container">
              <app-projects-table #projects [isHistory]="false"></app-projects-table>
            </div>
          </div>
        </ng-template>
        <ng-template ds-tab [label]="appStrings.followUp_projects_historyTitle">
          <div class="projects-content">
            <div id="data-container" class="data-container">
              <app-projects-table #projectsHistory [isHistory]="true"></app-projects-table>
            </div>
          </div>
        </ng-template>
      </ds-tabs>
    </div>
  </mat-expansion-panel>

  <!-- mobile template -->
  <mat-expansion-panel *appIsMobile [expanded]="false" class="mobile">
    <mat-expansion-panel-header>
      <mat-panel-title id="follow-up-header-container">
        <span class="follow-up-header-title">
          <span id="follow-up-title" class="title">
            {{ appStrings.followUp_title }}
          </span>
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ds-divider></ds-divider>
    <div class="tabs-container">
      <ds-button-toggle-legacy class="ellipsis-toggle four-tabs" (onClick)="onTabChangeMobile($event)" [toggleValues]="mobileToggleValues" size="medium" type="outlined" [selectedIndex]="activeTab" [isMultipleSelection]="false"></ds-button-toggle-legacy>
      @if (activeTab === tabs.Leads) {
        <div>
          <div id="leads-actions-container" class="actions-container">
            <app-follow-up-search [accountManagerEmployeeId]="accountManagerEmployeeId" [activeTab]="tabs.Leads" (searchEvent)="searchLeads()"></app-follow-up-search>
          </div>
          <app-leads-table #leads [isHistory]="false"></app-leads-table>
        </div>
      }
      @if (activeTab === tabs.LeadsHistory) {
        <div>
          <div id="history-actions-container" class="actions-container">
            <app-follow-up-search [accountManagerEmployeeId]="accountManagerEmployeeId" [activeTab]="tabs.LeadsHistory" (searchEvent)="searchLeadsHistory()"></app-follow-up-search>
          </div>
          <app-leads-table #leadsHistory [isHistory]="true"></app-leads-table>
        </div>
      }
      @if (activeTab === tabs.Projects) {
        <div>
          <div id="open-projects-actions-container" class="actions-container">
            <app-follow-up-search [accountManagerEmployeeId]="accountManagerEmployeeId" [activeTab]="tabs.Projects" (searchEvent)="searchProjects()"></app-follow-up-search>
            <ds-button size="medium" type="tertiary" variant="label-icon" icon="add" [label]="appStrings.button_addNew"
              iconPosition="left" iconStyle="material-icons" (onClick)="addNewProject()"
            ></ds-button>
          </div>
          <app-projects-table #projects [isHistory]="false"></app-projects-table>
        </div>
      }
      @if (activeTab === tabs.ProjectsHistory) {
        <div>
          <div id="open-projects-actions-container" class="actions-container">
            <app-follow-up-search [accountManagerEmployeeId]="accountManagerEmployeeId" [activeTab]="tabs.ProjectsHistory" (searchEvent)="searchProjectsHistory()"></app-follow-up-search>
          </div>
          <app-projects-table #projectsHistory [isHistory]="true"></app-projects-table>
        </div>
      }
    </div>
  </mat-expansion-panel>